import { render, staticRenderFns } from "./ReportMain.vue?vue&type=template&id=23c0215c&scoped=true&"
import script from "./ReportMain.vue?vue&type=script&lang=js&"
export * from "./ReportMain.vue?vue&type=script&lang=js&"
import style0 from "./ReportMain.vue?vue&type=style&index=0&id=23c0215c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0215c",
  null
  
)

export default component.exports